<template>
  <div
    class="story-card relative border-round-lg overflow-hidden cursor-pointer"
    @click="abrir"
  >
    <img class="story-card-capa" :src="value.imagem" alt="" />
    <div class="story-card-scrim absolute bottom-0 left-0 w-full"></div>

    <span class="story-card-anel absolute" :class="{ visto }">
      <img class="story-card-avatar" :src="avatar" alt="" />
    </span>

    <span
      class="story-card-nome absolute bottom-0 left-0 w-full text-white font-semibold"
    >
      {{ value.nome }}
    </span>
  </div>
</template>

<script>
export default {
  name: "StoryCard",
  props: {
    // { id, video, imagem, icone, nome, duracao }
    value: { type: Object, required: true },
  },
  data() {
    return {
      visto: false,
    };
  },
  computed: {
    avatar() {
      const ic = this.value.icone;
      if (!ic || ic === "null") {
        return this.$root.empresa ? this.$root.empresa.foto : "";
      }
      return ic;
    },
    chaveVistos() {
      const id = this.$root.empresa ? this.$root.empresa.id : "geral";
      return "stories_vistos_" + id;
    },
  },
  mounted() {
    try {
      const bruto = localStorage.getItem(this.chaveVistos);
      const vistos = bruto ? JSON.parse(bruto) : [];
      this.visto = vistos.includes(this.value.id);
    } catch (e) {
      this.visto = false;
    }
  },
  methods: {
    abrir() {
      this.$router.push({
        name: "mostrastorys",
        params: { id: this.value.id },
      });
    },
  },
};
</script>

<!-- Card com capa + avatar sobreposto + scrim: mesmo tipo de exceção que o
     Status já usava (scoped). Restante apoiado em utilitários PrimeFlex. -->
<style scoped>
.story-card {
  height: var(--h16x9);
  background: #0d1b3e;
}
.story-card-capa {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.story-card-scrim {
  height: 45%;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0));
}
.story-card-anel {
  top: 0.6rem;
  left: 0.6rem;
  padding: 2px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ba7517, #1d9e75);
  display: inline-flex;
}
.story-card-anel.visto {
  background: #e5e7eb;
}
.story-card-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #ffffff;
  display: block;
}
.story-card-nome {
  padding: 0.5rem;
  font-size: 0.8rem;
  line-height: 1.15;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}
</style>
